import React, { useEffect, useState } from "react";
import { kodeAkunTable } from "./kodeAkunTable";
import { kodeAkunFormData } from "./kodeAkunFormData";

// API
import {
  getAllDataTableAkuns,
  insertNewAkun,
  deleteAkun,
  updateAkun,
  getFilteredKodeAkun,
} from "./api/kodeAkunAPI";
import { getDropdownSubChildCategory } from "./../../config/akunSubChildCategory/api/akunSubChildCategoryAPI";

// Component
import CardTable from "components/Cards/CardTable";
import FormCustom from "components/Forms/FormCustom";
import ConfirmModal from "components/Modal/ConfirmModal";

import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router";
import { kodeAkunFilter } from "./kodeAkunFilterData";
import { getDropdownSubCategory } from "views/admin/config/akunSubCategory/api/akunSubCategoryAPI";

export default function KodeAkun() {
  const history = useHistory();

  const [addForm, setAddForm] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [editFormValue, setEditFormValue] = useState(null);

  const [dataTable, setDataTable] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  const [formData, setFormData] = useState(null);

  const [formDataArr, setFormDataArr] = useState([]);

  // Select-Option Data
  const [dropdownSubCategory, setDropdownSubCategory] = useState([]);
  const [dropdownSubChildCategory, setDropdownSubChildCategory] = useState([]);

  // type Search
  const [typeSearch, setTypeSearch] = useState("");

  // Filter Data
  const [filterData, setFilterData] = useState(null);

  //   Filter Data Arr
  const [filterDataArr, setFilterDataArr] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);
  const [deletePopUp, setDeletePopUp] = useState([{ show: false, id: null }]);

  // Component is Active?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // Intentionally Delay Process (Should use Async / Await)
  // function sleep(ms) {
  //     return new Promise(resolve => setTimeout(resolve, ms));
  // }

  // Load Data Table
  useEffect(() => {
    setIsLoading(true);
    if (active === true) {
      getAllDataTableAkuns()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }

    return () => {
      setDataTable([]);
    };
  }, [active]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, []);

  // Select-Option Data
  // Load Data Sub Child Category
  useEffect(() => {
    setIsLoading(true);

    getDropdownSubChildCategory()
      .then((response) => {
        setDropdownSubChildCategory(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownSubChildCategory([]);
    };
  }, [active]);

  // Load Data Sub Category
  useEffect(() => {
    setIsLoading(true);

    getDropdownSubCategory()
      .then((response) => {
        setDropdownSubCategory(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownSubCategory([]);
    };
  }, [active]);
  // End Select-Option Data

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(kodeAkunFormData(dropdownSubChildCategory));

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownSubChildCategory]);

  //   Load Filter Data Arr
  useEffect(() => {
    setFilterDataArr(kodeAkunFilter(dropdownSubCategory));

    return () => {
      setFilterDataArr([]);
    };
  }, [dropdownSubCategory]);

  // Handle when User Click Add Button
  function handleInsert() {
    // console.log(formDataArr);
    setActive(false);
    setAddForm(true);
  }

  // Handle when User Click Cancel
  const handleCancelButton = () => {
    setAddForm(false);
    setEditForm(false);
    setEditFormValue(null);
    setFormData(null);
    setActive(true);
  };

  // Handle when User Click Edit Button
  const handleEdit = (rowData) => {
    setActive(false);
    setEditFormValue(rowData);
    // console.log(rowData);
    setEditForm(true);
  };

  // Handle when User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_sistem_akun,
    });
  };

  // Handle when User Confirm to Delete Data
  const handleDeleteTrue = () => {
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteAkun(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle when User Deny to Confirm Delete Data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle when User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewAkun(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  // Handle when User Submit Update Data
  const handleUpdateSubmit = (e) => {
    e.preventDefault();
    if (formData !== null) {
      const id = editFormValue.id_sistem_akun;

      setIsLoading(true);

      updateAkun(id, formData)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    } else {
      toast.error("Tidak ada Data yg di Ubah");
    }
  };

  // Check if Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setFormData(null);
        setAddForm(false);
        setEditForm(false);
        setActive(true);
        history.push("/masterData");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Get Data
  // const getData = (key) => {
  //     return formData.hasOwnProperty(key) ? formData[key] : '';
  // }

  // Set Inputted Data to Form
  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  //   Set Inputed Data Filter to State filterData
  const setDataFilter = (key, value) => {
    return setFilterData({ ...filterData, [key]: value });
  };

  // Handle when Submit Process End
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setIsLoading(false);
  };

  //   Handle when User Click Button Filter Data
  const handleFilter = () => {
    if (filterData !== null) {
      getFilteredKodeAkun(filterData)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    }
  };

  //   Handle when User Click Button Reset Filter Data
  const handleResetFilter = () => {
    setFilterData(null);
    getAllDataTableAkuns()
      .then((response) => {
        setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));
    setPageNumber(0);
  };

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when Searching Changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getAllDataTableAkuns(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getAllDataTableAkuns()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              // getData = {getData}
              editFormValue={null}
            />
          </div>
        </div>
      </div>
    );

  if (editForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Edit Data"}
              formDataArr={formDataArr}
              handleSubmit={handleUpdateSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              // getData = {getData}
              editFormValue={editFormValue}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {deletePopUp.show && (
            <div>
              <ConfirmModal
                handleIfTrue={(e) => handleDeleteTrue()}
                handleIfFalse={(e) => handleDeleteFalse()}
              />
            </div>
          )}
          <Toaster />
          <CardTable
            tableTitle="Tabel Master Kode Akun"
            cols={kodeAkunTable(handleEdit, handleDelete)}
            handleInsert={(e) => handleInsert()}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
            handleFilter={(e) => handleFilter()}
            handleResetFilter={(e) => handleResetFilter()}
            filterDataArr={filterDataArr}
            setDataFilter={setDataFilter}
          />
        </div>
      </div>
    </div>
  );
}
